<template>
  <LoadingScreen v-model="loading" />
  <Transition name="fade">
    <div ref="pform" class="pform" v-show="show">
      <div class="pform__slide" :class="{ 'pform__slide_shifted': step == 3 }">
        <div class="wrapper-section">
          <Backlink :hidemode="step == 1" class="pform__backlink" />
          <div class="pform__inner">
            <h2 class="pform__title" :class="{ 'pform__title_nospace': step == 2 }">Отправка доп. файлов <br class="onlydesk">к Заявлению <br class="onlynano">на первичное <br class="onlymob">обращение<br class="onlydesk"> по&nbsp;типу «Страховой&nbsp;случай»</h2>
            <ProgressBar class="pform__bar" />
            <form @submit.stop.prevent class="pform__window" id="pform-form">
              <div ref="stepwindow" class="pform__stepwindow" :style="{ 'transform': `translateX(${(step - 1) * 100 * (-1)}%)` }">
                <Step6 :active="step == 1" />
                <Step8 :active="step == 2" />
<!--                <Step2 :active="step == 3" />
                <Step3 :active="step == 4" />
                <Step4 :active="step == 5" />
                <Step6 :active="step == 6" />
                <Step7 :active="step == 7" />
                <Step8 :active="step == 8" />-->
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="pform__slide" :class="{ 'pform__slide_shifted': step == 3 }">
        <CodeScreen />
      </div>
    </div>
  </Transition>
  <ThanksPopup />
  <ErrorPopup />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LoadingScreen from './components/LoadingScreen.vue';
import Backlink from './components/Backlink.vue';
import ProgressBar from './components/pbar/ProgressBar.vue';
// import Step1 from './components/steps/Step1.vue';
// import Step2 from './components/steps/Step2.vue';
// import Step3 from './components/steps/Step3.vue';
// import Step4 from './components/steps/Step4.vue';
// import Step5 from './components/steps/Step5.vue';
import Step6 from './components/steps/Step6.vue';
// import Step7 from './components/steps/Step7.vue';
import Step8 from './components/steps/Step8.vue';
import CodeScreen from './components/CodeScreen.vue';
import ThanksPopup from './components/ThanksPopup.vue';
import ErrorPopup from './components/ErrorPopup.vue';


export default {
  name: 'App',
  components: { LoadingScreen, Backlink, ProgressBar, /*Step1, Step2, Step3, Step4, Step5,*/ Step6, /*Step7,*/ Step8, CodeScreen, ThanksPopup, ErrorPopup },
  computed: {
    ...mapState('ad_storage',['step', 'show', 'form']),
    ...mapGetters('ad_storage',['loading'])
  },
  methods: {
  },
  mounted() {
    let v = this.$store.state.version

    if (v) {
      let el = document.createElement('div')
      el.classList.add('pform-version')
      el.innerHTML = v
      document.body.append(el)
    }
  },
  created() {
    let save = localStorage.getItem('personal_form_add_docs')
    if (save && (save != 'undefined')) {
      save = JSON.parse(save)
      for (let i in save.files)
        save.files[i] = []
      this.$store.commit('ad_storage/setForm', save)
    }
  },
  watch: {
    step(val, old) {
      this.$refs.pform.scrollTo({
        top: 0,
        behavior: "smooth",
      })
      this.$refs.stepwindow.scrollTo({
        top: 0,
        behavior: "smooth",
      })
      if (val == 3 && old == 2)
        this.$store.dispatch('ad_storage/sendCode')
    },
  }
}
</script>

<style lang="sass">
.pform-version
  position: fixed
  z-index: 2147000000
  bottom: 10px
  left: 10px
  padding: 5px 10px
  background: white
  color: black
  font-weight: 700
  font-size: 12px
  border-radius: 20px
  opacity: .5
  border: 1px solid rgba(0,0,0,.5)
  font-family: 'Muller', sans-serif
.fade-enter-from,.fade-leave-to, .fastfade-enter-from,.fastfade-leave-to
  opacity: 0
  pointer-events: none
.fastfade-enter-active,.fastfade-leave-active
  transition: opacity .2s ease-out
.fade-enter-active,.fade-leave-active
  transition: background .5s ease, opacity .4s ease-out
body
  margin: 0
  background: #fff
  color: #797979
  min-height: 100vh
  display: flex
  flex-direction: column
.nowrap
  white-space: nowrap
#app
  flex-grow: 1
.pform
  /*
    --headeroffset: 79px
    @include from(1135px)
      --headeroffset: 134px
    @include for-mob
      --headeroffset: 64px
  --headeroffset: 0px
  position: relative
  top: var(--headeroffset)
  left: 0
  width: 100%
  height: calc(100% - var(--headeroffset))  
  overflow-x: hidden
  overflow-y: auto
  color: colors.$gray5
  background: colors.$mainbg
  transition: background .5s ease, opacity .4s ease-out
  display: flex
  *
    font-family: globalvars.$font6
    letter-spacing: globalvars.$onespacing
  .newred
    color: colors.$newred !important
  &__slide
    width: 100%
    flex-shrink: 0
    transition: transform .6s ease-out
    &_shifted
      transform: translateX(-100%)
  img, svg
    display: block

  &__title
    font-weight: 500
    font-size: 36px
    line-height: 1.12
    margin: 0 0 63px
    color: colors.$bluefont
    text-align: center
    transition: margin-bottom .4s ease-out
    &_smspace
      margin-bottom: 24px
    &_nospace
      margin-bottom: 0px
  &__subtitle
    font-size: 24px
    line-height: 1.16
    margin-bottom: 8px
    color: colors.$gray3
    text-align: center
  &__bar
    margin-bottom: 42px
    @include for-mob
      margin-bottom: 26px
  .wrapper-section
    margin: 0 auto
    max-width: globalvars.$wrapper-width

    @include from(globalvars.$tablet)
      width: globalvars.$wrapper-tablet
      max-width: 100%
      min-width: 0
    @include for-mob
      width: globalvars.$wrapper-mob
  .onlydesk
    @include for-mob
      display: none !important
  .onlymob
    @include since(768px)
      display: none !important
  .onlynano
    @include since(450px)
      display: none !important
  &__inner
    width: 816px
    max-width: 100%
    margin: 0 auto
    align-items: center
    display: flex
    flex-direction: column
  &__window
    width: calc(100% + 60px)
    margin: 32px auto
    margin: 0 -30px
    overflow: hidden
  &__stepwindow
    display: flex
    width: 100%
    transition: transform .5s ease  
    >*
      width: 100%
      flex-shrink: 0
      padding: 0 30px 400px
      overflow: hidden
      margin-bottom: -150px
  *, &::before, &::after
    letter-spacing: var(--normspacing, .01em)
  @include for-mob
    &__title
      font-size: 28px
      line-height: 1.12
      margin: 0 0 40px
      &_smspace
        margin-bottom: 24px
a
  text-decoration: none
  color: inherit
button, input, optgroup, select, textarea
  font-family: inherit
  font-size: 100%
  line-height: 1.15
  margin: 0
  color: inherit
button, input
  overflow: visible
button, select
  text-transform: none
button, [type="button"], [type="submit"]
  -webkit-appearance: button
button::-moz-focus-inner, [type="button"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner
  border-style: none
  padding: 0
button:-moz-focusring, [type="button"]:-moz-focusring, [type="submit"]:-moz-focusring
  outline: 1px dotted ButtonText
[type="number"]
  &::-webkit-inner-spin-button, &::-webkit-outer-spin-button
    height: auto

*, *::after, *::before
  box-sizing: border-box
ul
  &, li
    padding: 0
    margin: 0
    list-style-type: none
button, [type='submit']
  background: none
  color: inherit
  border: none
  padding: 0
  font: inherit
  cursor: pointer
  outline: inherit
p
  margin: 0
</style>
